'use strict';

const _=require('pulsar-utils/dist-es6/_');
const BaseControllerBackedDirective=require('../../../dist-es6/client/angularCommon/baseControllerBackedDirective');let

DynamicStyleDirective=class DynamicStyleDirective extends BaseControllerBackedDirective{
get restrict(){
return'E';
}

get textBindings(){
return['cssPath'];
}

get objectBindings(){
return['styleDefinition'];
}

get template(){
return'<style type="text/css" data-ng-bind="controller.currentRule"></style>';
}

get controller(){
return DynamicStyleDirectiveController;
}};let


DynamicStyleDirectiveController=class DynamicStyleDirectiveController{
static get $inject(){return['$scope']}

constructor($scope){
this._$scope=$scope;

$scope.$watch('controller.styleDefinition',(newDef,oldDef)=>{
if(newDef===oldDef){
return;
}

this._setNewRule(newDef);
});

this._setNewRule(this.styleDefinition);
}

_setNewRule(rule){
this._$scope.$evalAsync(()=>{
if(!rule){
this.currentRule=`${this.cssPath} { }`;
return;
}

this.currentRule=`${this.cssPath} { ${rule} }`;
});
}};


module.exports=DynamicStyleDirective;
//# sourceMappingURL=dynamicStyleDirective.js.map
